export default __webpack_public_path__ + "static/media/icon-info.b3390055.svg";